export default __webpack_public_path__ + "static/media/about.0f54d998.png";